import {toast} from "react-toastify";

const defaultErrorMessage = "An error occurred. If the problem persists, please contact your team administrator.";

export async function getEntity(dispatch, entityOperation, isList, errorMessage) {
    const entityResponse = await dispatch(entityOperation);
    const _errorMessage = errorMessage || defaultErrorMessage;

    if (!wasSuccessfulOperation(entityResponse, _errorMessage)) {
        throw _errorMessage
    }

    if (!entityResponse) {
        return false;
    }
    
    return isList ? entityResponse.body._items : entityResponse.body
}

const wasSuccessfulOperation = (entityResponse, errorMessage) => {
    if (!respondToEntityOperation(entityResponse)) {
        return toastError(errorMessage);
    }
    return true
};

const respondToEntityOperation = (entityResponse, successPath, toastMessage, props) => {
    const _props = (this && this.props) || props;
    if (entityResponse
        && (entityResponse.error || (entityResponse.body && entityResponse.body._error))) {
        const errorMessage = entityResponse.error
            ? entityResponse.error.message
            : entityResponse.body._error.message;

        toast.error(errorMessage, {position: toast.POSITION.TOP_CENTER});
        return false
    } else {
        if (successPath) {
            _props.history.push(successPath);
        }
        if (toastMessage) {
            toast.success(toastMessage, {position: toast.POSITION.TOP_CENTER})
        }
        return true
    }
};

const toastError = (message) => {
    toast.error(message, {position: toast.POSITION.TOP_CENTER});
};



// WEBPACK FOOTER //
// ./src/services/entity/entity-service.js